module.exports = __webpack_public_path__ + "static/media/Interoperability_of_ePharmacie_Slide5_French.3e5c3832.png";